import { Outlet, useLocation, useMatch } from 'react-router-dom';
import { AppSidebar } from '@/components/app-sidebar';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Separator } from '@/components/ui/separator';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';

const ROUTE_LABELS: Record<string, string> = {
  '/orgs': 'Organizations',
  '/billing': 'Billing',
  '/audit': 'Audit log',
  '/dlq': 'Dead-letter queue',
  '/sandboxes': 'Sandboxes',
  '/force-cancel': 'Force-cancel run',
};

function useBreadcrumb(): { section: string; leaf?: string } {
  const { pathname } = useLocation();
  const orgDetail = useMatch('/orgs/:id');
  if (orgDetail) {
    return { section: 'Organizations', leaf: orgDetail.params.id };
  }
  const top = '/' + (pathname.split('/')[1] ?? '');
  const label = ROUTE_LABELS[top] ?? 'Backoffice';
  return { section: label };
}

export function Layout() {
  const crumb = useBreadcrumb();
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 h-4" />
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem className="hidden md:block">
                <BreadcrumbLink href="/orgs">Backoffice</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="hidden md:block" />
              {crumb.leaf ? (
                <>
                  <BreadcrumbItem className="hidden md:block">
                    <BreadcrumbLink href="/orgs">{crumb.section}</BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator className="hidden md:block" />
                  <BreadcrumbItem>
                    <BreadcrumbPage className="font-mono text-xs">{crumb.leaf}</BreadcrumbPage>
                  </BreadcrumbItem>
                </>
              ) : (
                <BreadcrumbItem>
                  <BreadcrumbPage>{crumb.section}</BreadcrumbPage>
                </BreadcrumbItem>
              )}
            </BreadcrumbList>
          </Breadcrumb>
        </header>
        <div className="flex flex-1 flex-col gap-4 p-6">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
